// Ce fichier gère l'enregistrement et la mise à jour du service worker

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    // Utiliser import.meta.env.BASE_URL pour Vite
    const baseUrl = import.meta.env.BASE_URL || '/';
    const publicUrl = new URL(baseUrl, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    // Délai plus court pour éviter les timeouts
    setTimeout(() => {
      const swUrl = `${baseUrl}service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log('Service Worker prêt en mode localhost');
        });
      } else {
        registerValidSW(swUrl, config);
      }
    }, 100); // Réduit de 100ms pour éviter les conflits
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('Service Worker enregistré:', registration);

      // Vérifier les mises à jour toutes les heures
      setInterval(() => {
        console.log('Vérification automatique des mises à jour...');
        registration.update();
      }, 60 * 60 * 1000); // Toutes les heures

      // Vérifier les mises à jour au focus de la fenêtre
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        console.log('Nouveau Service Worker actif - rechargement...');
        refreshing = true;
        window.location.reload();
      });

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // Nouvelle version disponible
              console.log('Nouvelle version disponible! Mise à jour en cours...');

              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }

              // Afficher une notification à l'utilisateur
              showUpdateNotification(registration);
            } else {
              // Première installation
              console.log('Contenu mis en cache pour utilisation hors ligne.');

              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Erreur lors de l\'enregistrement du Service Worker:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('Pas de connexion internet. L\'application fonctionne en mode hors ligne.');
    });
}

function showUpdateNotification(registration) {
  // Créer une notification visuelle pour l'utilisateur
  const updateBanner = document.createElement('div');
  updateBanner.id = 'update-banner';
  updateBanner.style.cssText = `
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #4CAF50;
    color: white;
    padding: 15px 30px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    z-index: 10000;
    display: flex;
    align-items: center;
    gap: 15px;
    font-family: Arial, sans-serif;
    animation: slideDown 0.5s ease-out;
  `;

  updateBanner.innerHTML = `
    <style>
      @keyframes slideDown {
        from {
          opacity: 0;
          transform: translateX(-50%) translateY(-20px);
        }
        to {
          opacity: 1;
          transform: translateX(-50%) translateY(0);
        }
      }
      #update-banner button {
        background-color: white;
        color: #4CAF50;
        border: none;
        padding: 8px 20px;
        border-radius: 5px;
        cursor: pointer;
        font-weight: bold;
        transition: all 0.3s ease;
      }
      #update-banner button:hover {
        background-color: #f0f0f0;
        transform: scale(1.05);
      }
    </style>
    <span>🎉 Une nouvelle version est disponible!</span>
    <button id="update-button">Mettre à jour maintenant</button>
  `;

  document.body.appendChild(updateBanner);

  // Gestionnaire de clic pour le bouton de mise à jour
  document.getElementById('update-button').addEventListener('click', () => {
    // Envoyer un message au service worker pour qu'il s'active immédiatement
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }

    // Masquer la bannière
    updateBanner.style.animation = 'slideDown 0.5s ease-out reverse';
    setTimeout(() => {
      updateBanner.remove();
    }, 500);
  });

  // Fermer automatiquement après 30 secondes et forcer la mise à jour
  setTimeout(() => {
    if (document.getElementById('update-banner')) {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      updateBanner.style.animation = 'slideDown 0.5s ease-out reverse';
      setTimeout(() => {
        updateBanner.remove();
      }, 500);
    }
  }, 30000);
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
